import * as React from "react";

import { cn } from "@/lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = "text", ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-11 w-full rounded-xl border border-slate-300 bg-white px-4 text-sm font-medium text-slate-900 shadow-sm transition",
          "placeholder:text-slate-400 focus-visible:border-brand-blue-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue-medium focus-visible:ring-offset-2",
          "disabled:cursor-not-allowed disabled:opacity-60",
          "file:mr-2 file:border-0 file:bg-transparent file:text-sm file:font-medium",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";
